import React from 'react'
import Favourites from '../components/Body/Favourites'


function FavouritePage() {
    
  return (
    <Favourites />
  )
}

export default FavouritePage